import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetParamsAndResolver } from '@cbridge-utils/redux-observable';
import { DetailsSidebarAction } from '@cbridge-packages/details-sidebar';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SpreadProfileAction } from '../spreadProfile.action';

type IDependencies = IClientApiDependencySegment;

export const createSpreadProfileEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetParamsAndResolver(SpreadProfileAction.create.started),
  mergeMap(({ params, reject }) => {
    return dependencies.api.createSpreadProfile(params).pipe(
      mergeMap((result) => {
        const cleanedProfileWithId = {
          ...params,
          id: result.id,
        };

        return [
          SpreadProfileAction.create.done({ params, result: cleanedProfileWithId }),
          DetailsSidebarAction.close(),
        ];
      }),
      catchApiError((error) => {
        const isHandled = reject?.(error.errorCode, error.description, error.params);
        return [
          SpreadProfileAction.create.failed({ params, error }),
          ...(isHandled ? [] : [createApiErrorNotification(error)]),
        ];
      }),
    );
  }),
);
